import { render, staticRenderFns } from "./stockBlank.vue?vue&type=template&id=23022194"
import script from "./stockBlank.vue?vue&type=script&lang=js"
export * from "./stockBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports